/**
 * Skeleton rows the Level RMM mapping tables show while loading: enough to
 * fill the visible table on a large screen. These tables have no pagination,
 * so `itemsPerPage` only sets this count.
 */
export const LEVEL_SKELETON_ROWS = 15;
